import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { updateOttVideoDetails, updateScheduleDetails } from 'src/lib/redux';

import { ottVideoDetailsFetcher } from '../../fetchers/ott-fetcher';

const getConversationIdFromUrl = (): string => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('conversationId') || '';
};

type Props = {
  data: any;
  isLoading: boolean;
  refetch: () => void;
  isFetched: boolean;
  error: any;
};

const useOttVideoDetails = ({ childId, enabled }: { childId: string; enabled: boolean }): Props => {
  const dispatch = useDispatch();
  const { data, isLoading, refetch, isFetched, error } = useQuery(
    [
      'ott-video-details',
      {
        childId,
      },
    ],
    ottVideoDetailsFetcher,
    {
      enabled: enabled,
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      onSuccess: (responseData) => {
        const conversationId = getConversationIdFromUrl();
        dispatch(updateOttVideoDetails({ ottVideoDetails: { ...responseData?.data } }));
        dispatch(
          updateScheduleDetails({
            scheduleDetails: {
              _id: responseData?.data?.isLive
                ? responseData?.data?.scheduleId
                : responseData?.data?._id,
              conversationId,
              isChatEnabled: true,
              isEmojiEnabled: true,
              isLive: responseData?.data?.isLive,
              uWebSocketEnabled: true,
            },
          }),
        );
      },
    },
  );

  return {
    data,
    isLoading,
    refetch,
    isFetched,
    error,
  };
};

export default useOttVideoDetails;
